/* unplugin-vue-components disabled */import { render } from "./CDateHeader.vue?vue&type=template&id=67528178&scoped=true&ts=true"
import script from "./CDateHeader.vue?vue&type=script&lang=ts"
export * from "./CDateHeader.vue?vue&type=script&lang=ts"

import "./CDateHeader.vue?vue&type=style&index=0&id=67528178&lang=less&scoped=true"
import "./CDateHeader.vue?vue&type=style&index=1&id=67528178&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67528178"]])

export default __exports__